import { combineReducers } from 'redux'

import resultados from './despesasPorRubrica'

export default combineReducers({ resultados })
